export const PRODUCT_TYPE_SHOW = 'show';
export const PRODUCT_TYPE_EVENT = 'event';
export const PRODUCT_TYPE_VOUCHER = 'voucher';
export const PRODUCT_TYPE_SHOW_PRODUCT = 'showProduct';
export const PRODUCT_TYPE_EVENT_PRODUCT = 'eventProduct';
export const PRODUCT_ORDER_TYPE_OPTION = 'option';
export const PRODUCT_TYPE_VOUCHER_ITEM = 'voucheritem';
